import dayjs from 'dayjs';
import axios from 'axios';
import qs from 'query-string';
class BehaviorsMonitor {
    constructor() {
        this.serverURL = 'https://amerp.superboss.cc';
        /**
         * 日志等级上传策略
        - level 1:  1条上传
        - level 2:  5条上传
        - level 3: 10条上传
        - level 4: 20条上传
         */
        this.uploadLimit = {
            1: 1,
            2: 5,
            3: 10,
            4: 20,
            5: 100,
        };

        this.delayUploadMap = {};
        this.init();

        const instance = axios.create({});
        instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
        instance.defaults.timeout = 30000;

        this.axios = instance;
    }

    init() {
        this.initSettings();
        this.initUserDeviceData();


    }

    initSettings() {
        if (this.monitorSetting) return;
        this.monitorSetting = {
            monitorOn: 1,
        }
    }

    initUserDeviceData() {
        if (this.userDeviceData) return;
        const obj = {};
        obj.trackName = '';
        obj.trackId = '';
        obj.os = navigator.platform;
        obj.userDomain = location.host;
        this._getBrowserInfo(obj);
        this.userDeviceData = obj;
    }

    _getBrowserInfo(obj) {
        const agent = navigator.userAgent.toLowerCase();
        const regStr_ie = /msie [\d.]+;/gi;
        const regStr_ff = /firefox\/[\d.]+/gi;
        const regStr_chrome = /chrome\/[\d.]+/gi;
        const regStr_saf = /safari\/[\d.]+/gi;
        const regStr_ie11 = /rv:[\d.]+/gi;
        let browserInfo = '';
        let browserName = '';
        let verinfo = '';
        if (agent.indexOf('msie') > 0) {
            browserInfo = agent.match(regStr_ie);
            browserName = 'IE';
        } else if (agent.indexOf('firefox') > 0) {
            browserInfo = agent.match(regStr_ff);
            browserName = 'FireFox';
        } else if (agent.indexOf('chrome') > 0) {
            browserInfo = agent.match(regStr_chrome);
            browserName = 'Chrome';
        } else if (
            agent.indexOf('safari') > 0 &&
            agent.indexOf('chrome') < 0
        ) {
            browserInfo = agent.match(regStr_saf);
            browserName = 'Safari';
        } else if (agent.indexOf('rv:') > 0) {
            browserInfo = agent.match(regStr_ie11);
            browserName = 'IE';
        }
        verinfo = (browserInfo + '').replace(/[^0-9.]/gi, '');
        var ver = verinfo.split('.');
        verinfo = (ver[0] + '.' + ver[1] || 0) * 1;
        obj.browserString = navigator.userAgent;
        obj.browserType = browserName + verinfo;
    }

    _fn_get_storage_monitor(){
        return JSON.parse( localStorage.getItem('behaviors.monitor') || '{}' );
    }
    _fn_set_storage_monitor(level, data){
        var localData = this._fn_get_storage_monitor();
        localData[level] = data;
        localStorage.setItem( 'behaviors.monitor', JSON.stringify(localData) );
    }


    // 上报日志
    pub(data, opts = {}) {
        data = Object.assign({}, this.userDeviceData, data);
        this._fn_save_data_to_monitor(data, opts);
    }

    _fn_save_data_to_monitor(data, opts) {
        
        const userData = _globel_vm.$store.getters.userInfo || {};
        const fullPagePath = _globel_vm.$route.fullPath || '';
        data.opTime = dayjs().format("YYYY-MM-DD HH:mm:ss");
        data.userName = userData.name;
        data.userId = userData.staffId;
        data.companyName = userData.companyName || '';
        data.companyId = userData.companyId || '';
        data.trackName = `[快麦通][${fullPagePath}]${data.trackName}`;
        data.actionType = 'scm_pc'; // 用于在日志系统中和erp日志区分开;

        let level = data.errLevel || 4;
        // 当前等级待上传列表
        let localData = this._fn_get_storage_monitor();
        let thisLevelArr = localData[level];
        if (!thisLevelArr) {
            thisLevelArr = localData[level] = [];
        }


        // 当前等级上传策略限制
        let thisLevelLimit = this.uploadLimit[level];
        thisLevelArr.push(data);
        this._fn_set_storage_monitor(level, thisLevelArr);

        if (!opts.igLimit && (thisLevelArr.length < thisLevelLimit)) {
            return;
        }

        // 触发错误上传 合并其他错误列表,一起上传
        let postArray = [];
        Object.entries(this._fn_get_storage_monitor()).forEach(([level, levelErrorArr]) => {
            if (levelErrorArr) {
                postArray = postArray.concat(levelErrorArr);
            }
            this._fn_set_storage_monitor(level, [])  
        })

        let monitorObj = {};
        let printedExceptionArr = [];
        let monitorArr = [];
        postArray.forEach(errorInfo => {
            if (errorInfo.position) {
                // 合并重复的错误
                if (!monitorObj[errorInfo.position]) {
                    monitorObj[errorInfo.position] = errorInfo;
                    monitorArr.unshift(errorInfo);
                }
            } else {
                if (errorInfo.printedExceptionData) {
                    printedExceptionArr.unshift(Object.assign({}, errorInfo.printedExceptionData));
                    delete errorInfo.printedExceptionData;
                }
                monitorArr.unshift(errorInfo);
            }
        })

        console.log(`前端日志上传${monitorArr.length}条：`,monitorArr, `打印异常记录上传${printedExceptionArr.length}条：`,printedExceptionArr);
    
        // 上传到前端日志系统
        if (monitorArr.length && this.monitorSetting && this.monitorSetting.monitorOn == 1) {
            this.axios.post(this.serverURL + '/item/adddata', qs.stringify({
                postArray: JSON.stringify(monitorArr),
            }), {
                withCredentials: true,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                }
            }).then((data) => {
                console.info(data);
            }).catch((e) => {
                console.error(e);
            })
        }
    }

}

export default new BehaviorsMonitor();
